import { render, staticRenderFns } from "./buyAdvisory.vue?vue&type=template&id=6d9118ae&scoped=true"
import script from "./buyAdvisory.vue?vue&type=script&lang=js"
export * from "./buyAdvisory.vue?vue&type=script&lang=js"
import style0 from "./buyAdvisory.vue?vue&type=style&index=0&id=6d9118ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9118ae",
  null
  
)

export default component.exports